export const PROFILES_DOMAIN = 'profiles'
